import ptBR from './locales/pt-BR/index.js';
import enUS from './locales/en-US/index.js';
export const resources = {
    'pt-BR': ptBR,
    'en-US': enUS,
};
export const supportedLocales = Object.keys(resources);
export const defaultLocale = 'pt-BR';
export const namespaces = Object.keys(ptBR);
/** Templates de e-mail e mensagens do sistema (fora dos JSON de UI). */
export { emailTemplates } from './locales/pt-BR/email.js';
//# sourceMappingURL=index.js.map